import { faAngleDown, faAngleUp } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Collapse from '@material-ui/core/Collapse';
import { uniq } from 'lodash';
import React, { Component } from "react";
import { connect } from "react-redux";
import { DateFnsFormats, formatAs } from "../../../../common-client2/src/services/ukgDateTime";
import CheckBox from "../../../../common/components/UI/Checkbox/";
import { selectFilter } from "../../actions";
import JobFilter from "../Desktop/JobFilter";
import LocationFilter from '../Desktop/LocationFilter';
import './filterPanel.scss';

class FilterPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: {
                myItem: false,
                skipValidationOffers: false,
                myRequest: false,
                status: false
            }
        }
    }


    generateSections() {
        const { filters, storeData } = this.props;

        let myActiveManagerSettings = [0, 1]; // MyShift && Paycodes
		let availableActiveManagerSettings = [0, 1];
		myActiveManagerSettings = myActiveManagerSettings.concat(storeData.employeeShiftRequests.map(x => x.managerSettingId))
			.concat(storeData.employeeShiftOffers.map(x => x.managerSettingId))
			.concat(storeData.employeeMyShiftSwapOffers.map(x => x.managerSettingId))
			.concat(storeData.myProposals.map(x => x.managerSettingId))
			.concat(storeData.myOpenShiftRequests.map(x => x.managerSettingId))
			.concat(storeData.myVTORequests.map(x => x.managerSettingId));
		availableActiveManagerSettings = availableActiveManagerSettings.concat(storeData.availableShiftsToCover.map(x => x.managerSettingId))
			.concat(storeData.availableShiftToSwapOffers.filter(x => !x.isSkipValidation).map(x => x.managerSettingId))
			.concat(storeData.availableVTO.map(x => x.managerSettingId));
		let availableOpenShifts = storeData.availableOpenShifts.map(x => x.managerSettingIds);
		for (let os in availableOpenShifts) {
			availableActiveManagerSettings = availableActiveManagerSettings.concat(availableOpenShifts[os]);
		}
		myActiveManagerSettings = uniq(myActiveManagerSettings);
		availableActiveManagerSettings = uniq(availableActiveManagerSettings);

        const sectionsToSkip = ['location', 'job'];
        let sections = [];
        for (let section in filters) {
            if (sectionsToSkip.includes(section)) {
				continue;
			}
            sections.push(this.generateFilters(section, filters[section], myActiveManagerSettings, availableActiveManagerSettings));
        }

        return sections;
    };

    toggleCollapsable(title) {
        const { opened } = this.state;
        opened[title] = 1 - opened[title];
        this.setState({ opened });
    }


    generateFilters(title, section, myActiveManagerSettings, availableActiveManagerSettings) {
        const { classes, t } = this.props;
        const { opened } = this.state;
        const filterSections = [];

        filterSections.push(<hr />);
        filterSections.push(
            <div className={classes.filterTitle} onClick={() => { this.toggleCollapsable(title) }}>
                {t('filterPanel.' + title)}
                <FontAwesomeIcon icon={opened[title] ? faAngleUp : faAngleDown} style={{ float: "right", marginRight: "10px" }} />
            </div>
        );

        var filters = section.filters;
        if (title === "myItem") {
            filters = section.filters.filter(x => x.calendarIds.some(y => availableActiveManagerSettings.includes(parseInt(y))));
        } else if (title === "myRequest") {
            filters = section.filters.filter(x => x.calendarIds.some(y => myActiveManagerSettings.includes(parseInt(y))));
        }
        for (const filter of filters) {
            filterSections.push(
                <Collapse
                    in={opened[title]}
                    timeout={{ enter: 750, exit: 750 }}
                    style={{ transitionDelay: "250ms" }}
                >
                    <div className={classes.filterItem} >
                        <label key={filter.id} className={classes.checkBoxContainer}>
                            <CheckBox
                                color={filter.borderColor}
                                checked={filter.checked}
                                onChange={(e) => { this.handleCheckboxChange(filter, e) }}
                            />
                            <span style={{ marginLeft: 5 }}>{filter.name}</span>
                        </label>
                    </div>
                </Collapse>

            );
        }

        return filterSections;
    }

    handleCheckboxChange = (item, event) => {
        const { handleLoadToCoverOffers } = this.props
        this.props.selectFilter(item)

        let dates = this.findAffectedDates(item);
        handleLoadToCoverOffers(dates);
    }

    findAffectedDates = (item) => {
        const { storeData } = this.props;

        switch (item.parentCategory) {
            case 0: // My shifts, paycodes, available offers
                switch (item.calendarIds[0]) { // can this have a length >1 ?
                    case "0":
                        return storeData.employeeShifts.map(x => formatAs(x.startDateTime, DateFnsFormats.YMD));
                    case "1":
                        return storeData.employeePaycodes.map(x => formatAs(x.startDateTime, DateFnsFormats.YMD));
                    default:
                        let dates = [];
                        let availableTC = storeData.availableShiftsToCover.filter(x => !x.idOfPrivateEmployees.length
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        let filteredTC = availableTC.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                        let availableSS = storeData.availableShiftToSwapOffers.filter(x => !x.idOfPrivateEmployees.length
                            && !x.isSkipValidation
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        for (const x of availableSS) {
                            for (const shift of x.shifts) {
                                dates.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                            }
                        }
                        let availableOS = storeData.availableOpenShifts.filter(x => item.calendarIds.includes(x.toString()))
                        let filteredOS = availableOS.map(x => formatAs(x.startDate, DateFnsFormats.YMD))

                        let availableVTO = storeData.availableVTO.filter(x => x.type !== 1
                            && item.calendarIds.includes(x.managerSettingId.toString()))
                        let filteredVTO = availableVTO.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                        dates.push(...filteredTC)
                        dates.push(...filteredOS)
                        dates.push(...filteredVTO)
                        return dates;
                }
            case 1: // My reqs
                let dates1 = []
                let myTCRequests = storeData.employeeShiftRequests.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredMyTCRequests = myTCRequests.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let myTCOffers = storeData.employeeShiftOffers.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredMyTCOffers = myTCOffers.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let mySSOffers = storeData.employeeMyShiftSwapOffers.filter(x => !x.idOfPrivateEmployees.length && item.calendarIds.includes(x.managerSettingId.toString()))
                for (const x of mySSOffers) {
                    for (const shift of x.shifts) {
                        dates1.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myProposals = storeData.myProposals.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                for (const x of myProposals) {
                    for (const shift of x.shifts) {
                        dates1.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myOSRequests = storeData.myOpenShiftRequests.filter(x => item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredmyOSRequests = myOSRequests.map(x => formatAs(x.startDate, DateFnsFormats.YMD))
                let myVTORequests = storeData.myVTORequests.filter(x => x.voluntaryTimeOffType !== 1 && item.calendarIds.includes(x.managerSettingId.toString()))
                let filteredVTORequests = myVTORequests.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                dates1.push(...filteredMyTCRequests)
                dates1.push(...filteredMyTCOffers)
                dates1.push(...filteredmyOSRequests)
                dates1.push(...filteredVTORequests)
                return dates1;
            case 2: //By status
                let dates2 = [];
                let availableTC2 = storeData.availableShiftsToCover.filter(x => !x.idOfPrivateEmployees.length
                    && item.statusIds.includes(x.status))
                let filteredTC2 = availableTC2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let availableSS2 = storeData.availableShiftToSwapOffers.filter(x => !x.idOfPrivateEmployees.length
                    && item.statusIds.includes(x.status))
                for (const x of availableSS2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let availableOS2 = storeData.availableOpenShifts.filter(x => item.calendarIds.includes(0))
                let filteredOS2 = availableOS2.map(x => formatAs(x.startDate, DateFnsFormats.YMD))

                let availableVTO2 = storeData.availableVTO.filter(x => x.type !== 1
                    && item.statusIds.includes(x.status))
                let filteredVTO2 = availableVTO2.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                let myTCRequests2 = storeData.employeeShiftRequests.filter(x => item.statusIds.includes(x.status))
                let filteredMyTCRequests2 = myTCRequests2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let myTCOffers2 = filteredMyTCRequests2.filter(x => item.statusIds.includes(x.status))
                let filteredMyTCOffers2 = myTCOffers2.map(x => formatAs(x.isPartial ? x.partialFromDate : x.shift.startDateTime, DateFnsFormats.YMD))
                let mySSOffers2 = storeData.employeeMyShiftSwapOffers.filter(x => !x.idOfPrivateEmployees.length && item.statusIds.includes(x.status))
                for (const x of mySSOffers2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myProposals2 = storeData.myProposals.filter(x => item.statusIds.includes(x.status))
                for (const x of myProposals2) {
                    for (const shift of x.shifts) {
                        dates2.push(formatAs(shift.startDateTime, DateFnsFormats.YMD))
                    }
                }
                let myOSRequests2 = storeData.myOpenShiftRequests.filter(x => item.statusIds.includes(x.status))
                let filteredmyOSRequests2 = myOSRequests2.map(x => formatAs(x.startDate, DateFnsFormats.YMD))
                let myVTORequests2 = storeData.myVTORequests.filter(x => x.voluntaryTimeOffType !== 1 && item.statusIds.includes(x.status))
                let filteredVTORequests2 = myVTORequests2.map(x => formatAs(x.timeOffStartDate, DateFnsFormats.YMD))

                dates2.push(...filteredTC2)
                dates2.push(...filteredOS2)
                dates2.push(...filteredVTO2)
                dates2.push(...filteredMyTCRequests2)
                dates2.push(...filteredMyTCOffers2)
                dates2.push(...filteredmyOSRequests2)
                dates2.push(...filteredVTORequests2)
                return dates2;
            case 3:
                let dates3 = [];
                let availableSS3 = storeData.availableShiftToSwapOffers.filter(x =>
                    x.isSkipValidation &&
                    !x.idOfPrivateEmployees.length &&
                    item.calendarIds.includes(x.managerSettingId.toString())
                );
                for (const x of availableSS3) {
                    for (const shift of x.shifts) {
                        dates3.push(formatAs(shift.startDateTime, DateFnsFormats.YMD));
                    }
                }
                return dates3;    
            default: return [];
        }
    }

    render() {
        let sections = this.generateSections();
                return (
            <div>
                {sections}
                <hr />
                <LocationFilter />
                <hr />
                <JobFilter />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        storeData: state.data,
    };
};

export default connect(mapStateToProps, { selectFilter })(FilterPanel);
